module.exports = __webpack_public_path__ + "static/fanny_nieuw-d619bf54df38dd9078abdb315424fe7c.jpg";